export const LOCATION_WAIT_THRESHOLD_MS = 15 * 1000;
export const MAP_SEARCH_HERE_THRESHOLD_METERS = 50 * 10 ** 3;

// This is needed for performance.
export const MAX_DEALERS_PER_SEARCHLIST = 30;

export const MAP = {
  minZoom: 4,
  maxZoom: 16,
};

export const MIN_ZOOM_TO_SEARCH = 8;
export const ZOOM_STEP = 1;
